import React from "react";
import { Landing } from "../../components";
import { homeObjectThree } from "./data";

const Products = () => {
  return (
    <>
      <Landing {...homeObjectThree} />
    </>
  );
};

export default Products;
